export function useActiveMedia() {
  return useState<HTMLMediaElement | null>('active-media')
}
